import React from 'react';

import Header from "../components/Header"; // Adjust the path to match your project structure


const PrivacyPolicy = () => {
  return (

<>
<Header />
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-emerald max-w-none">
          <p className="text-lg text-gray-500 mb-8">
            Last updated: February 11, 2025
          </p>

          {/* 1. Introduction */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
            <p className="text-gray-600 mb-4">
              At <strong>Spirara</strong>, we prioritize your privacy 
              and are committed to maintaining the integrity of your personal information. 
              This privacy policy is designed to inform you about our practices concerning 
              the collection, use, and sharing of your information. 
            </p>
          </section>

          {/* 2. Account Creation and Information Collection */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Account Creation and Information Collection</h2>
            <p className="text-gray-600 mb-4">
              When you create an account with Spirara, we collect essential information such as your 
              username, email address, and a secure password to provide you with a personalized 
              and secure experience. This information enables us to manage your account, authenticate 
              your logins, and offer customer support.
            </p>
          </section>

          {/* 3. Data Usage and Backup */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Data Usage and Backup</h2>
            <p className="text-gray-600 mb-4">
              Your data are stored both locally on your device and, if you opt-in, backed up 
              to your chosen cloud storage solution—Google Drive for Android users and Apple iCloud 
              for iOS users. This backup ensures that your data are not lost should you change 
              or lose your device and gives you control over its storage.
            </p>
          </section>

          {/* 4. Analytics and Crash Reporting with Firebase */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Analytics and Crash Reporting with Firebase
            </h2>
            <p className="text-gray-600 mb-4">
              Spirara uses <strong>Google Analytics for Firebase</strong> to collect anonymized usage data 
              and <strong>Firebase Crashlytics</strong> for crash reporting to improve app functionality 
              and user experience. These tools help us understand how users interact with our app and 
              quickly address any issues that arise.
            </p>
          </section>

          {/* 5. Information Obtained Through Support Channels */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Information Obtained Through Support Channels
            </h2>
            <p className="text-gray-600 mb-4">
              If you contact us for support, we will use your email address solely to correspond 
              with you regarding your inquiries or to provide assistance and important updates 
              about our services.
            </p>
          </section>

          {/* 6. Integration with Health Services */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Integration with Health Services</h2>
            <p className="text-gray-600 mb-4">
              Spirara offers integration with health-related services such as Apple Health, should you 
              choose to use this feature. Any health data imported into our app is handled with the utmost 
              confidentiality and is not shared with third parties.
            </p>
          </section>

          {/* 7. AI-Generated Insights */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. AI-Generated Insights</h2>
            <p className="text-gray-600 mb-4">
              As part of Spirara's features, your data may be processed by AI systems to provide 
              personalized insights and recommendations. This processing is conducted securely, 
              and your data is not shared outside the Spirara platform.
            </p>
          </section>

          {/* 8. Photo and Attachment Security */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Photo and Attachment Security</h2>
            <p className="text-gray-600 mb-4">
              If you attach photos or files to your entries in Spirara, these are stored on your device 
              and included in your backups if you choose to use cloud backup services. We ensure that 
              these files remain under your control and are not accessible to Spirara.
            </p>
          </section>

          {/* 9. Updates to Our Privacy Policy */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Updates to Our Privacy Policy</h2>
            <p className="text-gray-600 mb-4">
              We reserve the right to amend this privacy policy at our discretion and will provide 
              notice of any significant changes through our website or app. You are encouraged 
              to review our policy periodically to stay informed about how we are protecting 
              your information.
            </p>
            <p className="text-gray-600 mb-4">
              By using Spirara, you consent to our collection, use, and sharing of your information 
              as described in this policy. Your continued use of our services after any changes 
              to this policy constitutes your acceptance of the new terms.
            </p>
          </section>

          {/* 10. Contacting Us */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contacting Us</h2>
            <p className="text-gray-600 mb-4">
              For any questions or concerns regarding your privacy, please email us at{" "}
              <strong>admin@rezonata.xyz</strong>.
            </p>
            <p className="text-gray-600 mb-4">
              Spirara is dedicated to ensuring your privacy is respected and protected 
              in accordance with applicable data protection regulations.
            </p>
          </section>
        </div>

        <footer className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-500 text-sm text-center">
            © 2025 Spirara. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
    </>

);
};

export default PrivacyPolicy;
